<template>
  <div class="icon" :style="{ width: `${$attrs.size}px`, height: `${$attrs.size}px` }"></div>
</template>

<script>
export default {};
</script>

<style scoped>
.icon {
  background-image: url("@/assets/afreeca.png");
  background-size: cover;
  background-position: center;
}
</style>
